import {
  NumberPropertyDefinition,
  StringPropertyDefinition
} from '@shared/models/schema-property-definition';

export namespace ContactReferrerArrangement {
  export enum Type {
    No = 'No',
    YesNoBenefit = 'Yes - no referrer fee/benefit',
    YesBenefit = 'Yes - referrer fee/benefit'
  }

  export enum UpfrontType {
    Amount = 'Amount',
    Percent = 'Percent'
  }
  export interface SchemaPropertyDefinition {
    payeeName: StringPropertyDefinition;
    upfront: {
      amount: NumberPropertyDefinition;
      percent: NumberPropertyDefinition;
    };
    trail: NumberPropertyDefinition;
  }

  export interface SchemaContract {
    payeeName?: string | null;
    upfront?:
      | {
          amount: number | null;
        }
      | {
          percent: number | null;
        }
      | null;
    trail?: number | null;
  }

  export interface Model {
    payeeName: string | null;
    upfront: {
      type: UpfrontType | null;
      amount: number | null;
      percent: number | null;
    };
    trail: number | null;
  }

  export function toModel(value?: SchemaContract | null): Model | null {
    if (!value?.payeeName) {
      return null;
    }
    return {
      payeeName: value.payeeName,
      upfront: value.upfront
        ? {
            type:
              'amount' in value.upfront
                ? UpfrontType.Amount
                : UpfrontType.Percent,
            amount: 'amount' in value.upfront ? value.upfront.amount : null,
            percent: 'percent' in value.upfront ? value.upfront.percent : null
          }
        : {
            type: null,
            amount: null,
            percent: null
          },
      trail: value.trail || null
    };
  }

  export function toSchemaContract(value: Model | null): SchemaContract {
    if (!value) {
      return {};
    }
    return {
      payeeName: value.payeeName,
      upfront:
        value.upfront.type === UpfrontType.Amount
          ? {
              amount: value.upfront.amount
            }
          : value.upfront.type === UpfrontType.Percent
          ? {
              percent: value.upfront.percent
            }
          : null,
      trail: value.trail
    };
  }
}
